module.exports = __webpack_public_path__ + "static/media/Videos@2x.65548297.png";